import NewsletterForm from './NewsletterForm';

export default function Newsletter() {
  return (
    <section className="py-14 md:py-20 bg-accent-100/50">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-accent-200 flex items-center justify-center">
          <i className="ri-mail-send-line text-2xl text-accent-700"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">订阅我们的Newsletter</h2>
        <p className="mt-3 text-foreground-600 text-sm md:text-base mb-8">
          每周推送精选情感故事、心理分析和青春文学作品，让你的内心始终保有一份温柔的角落。
        </p>
        <div className="max-w-md mx-auto">
          <NewsletterForm formAction="https://readdy.ai/api/form/d9sqg1llbrt1qcgaj8b0" />
        </div>
      </div>
    </section>
  );
}